/*
 * newsbot - General tab for filter details
 * Fork of autobrr General.tsx pattern
 */

import { useFormikContext } from "formik";
import { FilterPage, FilterSection, FilterLayout } from "@/components/filters/_components";
import { TextField, NumberField, SwitchGroup } from "@/components/inputs";
import { ApiEndpointDisplay } from "@/components/filters/ApiEndpointDisplay";

interface GeneralFormValues {
  slug: string;
}

export function General() {
  const { values } = useFormikContext<GeneralFormValues>();

  return (
    <FilterPage>
      <FilterSection title="Basic Information" subtitle="Core filter settings">
        <FilterLayout>
          <TextField
            name="name"
            label="Name"
            columns={6}
            placeholder="e.g., Bitcoin News"
          />
          <TextField
            name="slug"
            label="Slug"
            columns={6}
            placeholder="e.g., bitcoin-news"
          />
          <NumberField
            name="priority"
            label="Priority"
            placeholder="Higher number = higher priority"
          />
          <SwitchGroup
            name="enabled"
            label="Enabled"
            description="Enable or disable this filter."
            className="pb-2 col-span-12 sm:col-span-6"
          />
        </FilterLayout>
      </FilterSection>

      {values.slug && (
        <FilterSection title="API Integration" subtitle="Endpoints for external integrations">
          <div className="col-span-12">
            <ApiEndpointDisplay slug={values.slug} />
          </div>
        </FilterSection>
      )}
    </FilterPage>
  );
}
